import React, { useEffect, useState, useCallback } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import SearchBar from '../../components/common/SearchBar';
import Pagination from '../../components/common/Pagination';
import StatusBadge from '../../components/common/StatusBadge';
import { getLoginHistoryList } from '../../api/history';
import { formatDateTime } from '../../utils/format';

export default function LoginHistoryPage() {
  const [condition, setCondition] = useState({ pageNo: 1, pageSize: 15 });
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchList = useCallback(async (cond) => {
    setLoading(true);
    setError('');
    try {
      const res = await getLoginHistoryList(cond);
      setPage(res.data);
    } catch (err) {
      setError(err.response?.data?.message || '로그인 이력을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchList(condition); }, [condition, fetchList]);

  return (
    <AdminLayout title="로그인이력관리" menuUrl="/admin/history/login">
      <div className="page-header">
        <div>
          <h1>로그인이력관리</h1>
          <div className="subtitle">관리자 로그인 시도 이력을 IP와 함께 조회합니다.</div>
        </div>
      </div>

      <div className="list-toolbar">
        <SearchBar placeholder="관리자 계정으로 검색" useDateRange
          onSearch={(cond) => setCondition((c) => ({ ...c, adminAccount: cond.searchKeyword, searchStartDate: cond.searchStartDate, searchEndDate: cond.searchEndDate, pageNo: 1 }))} />
      </div>

      <div className="list-count-bar">
        <span className="list-count">전체 <b>{page?.totalCount ?? 0}</b>건</span>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table className="data-table">
            <thead><tr><th>계정</th><th>결과</th><th>실패사유</th><th>접속 IP</th><th>일시</th></tr></thead>
            <tbody>
              {loading && <tr><td colSpan={5} className="empty-row">불러오는 중...</td></tr>}
              {!loading && error && <tr><td colSpan={5} className="empty-row error-state">{error}</td></tr>}
              {!loading && !error && page?.list?.length === 0 && <tr><td colSpan={5} className="empty-row">이력이 없습니다.</td></tr>}
              {!loading && !error && page?.list?.map((h) => (
                <tr key={h.loginHistId}>
                  <td>{h.adminAccount}</td>
                  <td><StatusBadge value={h.loginResult} /></td>
                  <td className="text-secondary">{h.failReason || '-'}</td>
                  <td>{h.loginIp}</td>
                  <td>{formatDateTime(h.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {page && <Pagination {...page} onChange={(pageNo) => setCondition((c) => ({ ...c, pageNo }))} />}
    </AdminLayout>
  );
}
